import React from 'react';
import {
    Select, Input, Form, Row, Col
} from 'antd';
import SSAS from '../../scripts/ssas'
import 'antd/dist/antd.css';
import '../../assets/css/style.css'
const { Option } = Select;

class CheckOnTagComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            number: [],
            submitdata: []
        }

    }
    componentDidMount = () => {
        const { store } = this.props;
        const _mbNumber = SSAS.pubXtszDqz(store, 'pub_kqmb_num');
        const _data = SSAS.sjzdDataSource(store, 'dm_xtgl_sjzd', '10195');
        let _number = [];
        let _index = _mbNumber ? parseInt(_mbNumber) : 3;
        for (let i = 1; i <= _index; i++) {
            _number.push(i);
        }
        this.setState({ number: _number, data: _data ? _data : [] });
    }

    submitdataUpdate = (parame) => {
        const { submitdata } = this.state;
        let data = [];
        let append = true;
        submitdata.map(item => {
            if (item.index === parame.index) {
                append = false;
                data.push(Object.assign({}, item, parame));
            }
            else {
                data.push(item);
            }
        });
        if (append) {
            data.push(parame);
        }
        this.setState({
            submitdata: data
        });
        setTimeout(() => {
            this.props.mbSubmitChange(data);
        }, 20);
    }
    render() {

        return (
            <Form layout="inline" style={{ paddingLeft: '10px' }}>
                {
                    this.state.number.map(i => {
                        return <Row>
                            <Col span={24}>
                                <Form.Item label={i.toString() + '、密保问题'}>
                                    <Select
                                        showSearch
                                        allowClear={true}
                                        placeholder="请选择密保问题"
                                        optionFilterProp="children"
                                        style={{ width: 300 }}
                                        onChange={value => this.submitdataUpdate({ index: i, qsmc: value })}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {
                                            this.state.data.map((menu, index) => {
                                                return (<Option value={menu.value}>{menu.label}</Option>)
                                            })
                                        }
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={24} style={{ paddingLeft: '20px' }}>
                                <Form.Item label={'密保答案'}>
                                    <Input
                                        allowClear={true}
                                        onChange={e => this.submitdataUpdate({ index: i, bzda: e.target.value })}
                                        placeholder="请输入密保答案"
                                        style={{ width: 300 }}
                                    >
                                    </Input>
                                </Form.Item>
                            </Col>
                        </Row>
                    })
                }
            </Form>
        )
    }
}
export default CheckOnTagComponent;